import { CHAT_AMPLITUDE_EVENTS } from '../types/events/chat'
import { ASSISTANT_AMPLITUDE_EVENTS } from '../types/events/assistant'
import { HIGHLIGHT_CHAT_AMPLITUDE_EVENTS } from '../types/events/highlight-chat'
import { getInstalledVersionWithSuffix, getStartupChannel } from '@shared/utils/builds/channels.shared'

const isDeveloper = process.env.NODE_ENV === 'development'
const log = {
  debug: (message: string) => console.debug(`[Amplitude] ${message}`),
  info: (message: string) => console.info(`[Amplitude] ${message}`),
  warn: (message: string) => console.warn(`[Amplitude] ${message}`),
  error: (message: string) => console.error(`[Amplitude] ${message}`),
}

export type AMPLITUDE_EVENTS = CHAT_AMPLITUDE_EVENTS & ASSISTANT_AMPLITUDE_EVENTS & HIGHLIGHT_CHAT_AMPLITUDE_EVENTS

export const logAmplitudeEvent = <TEventKey extends keyof AMPLITUDE_EVENTS>(
  event: TEventKey,
  ...args: AMPLITUDE_EVENTS[TEventKey] extends undefined ? [payload?: never] : [payload: AMPLITUDE_EVENTS[TEventKey]]
) => {
  const eventName = event.toString()
  const [payload] = args

  log.info(`trackEvent: ${eventName}, properties: ${JSON.stringify(payload ?? {})}`)

  const defaultProps = {
    isDeveloper: isDeveloper,
    platform: 'desktop',
    deviceFamily: process.platform === 'win32' ? 'Windows' : 'Mac',
    version: getInstalledVersionWithSuffix(),
    channel: getStartupChannel(),
    rendererName: (typeof window !== 'undefined' ? window : {}).__RENDERER_NAME ?? 'unknown',
  }

  if (typeof window !== 'undefined' && typeof window.ampltd !== 'undefined') {
    window.ampltd.trackEvent(eventName, {
      ...payload,
      ...defaultProps,
    })
  } else {
    console.warn(`[Amplitude] window.ampltd is not set, dropping ${eventName}`)
  }
}
